import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  CircularProgress,
} from '@mui/material';

interface Props {
  open: boolean;
  communityName: string;
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const DeleteCommunityDialog: React.FC<Props> = ({
  open,
  communityName,
  loading,
  onConfirm,
  onClose,
}) => {
  const [confirmName, setConfirmName] = useState('');

  useEffect(() => {
    if (!open) setConfirmName('');
  }, [open]);

  const nameMatches = confirmName.trim() === communityName;

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 600, color: '#d32f2f' }}>Delete community?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ color: '#5f6368', mb: 2 }}>
          This will permanently remove &ldquo;{communityName}&rdquo; for all members. Messages,
          invite links, and groups will be archived. This cannot be undone.
        </Typography>
        <Typography variant="body2" sx={{ color: '#5f6368', mb: 1 }}>
          Type <strong>{communityName}</strong> to confirm:
        </Typography>
        <TextField
          fullWidth
          size="small"
          value={confirmName}
          onChange={(e) => setConfirmName(e.target.value)}
          placeholder={communityName}
          autoComplete="off"
          disabled={loading}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={!nameMatches || loading}
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : 'Delete community'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
